// extracted by mini-css-extract-plugin
module.exports =  {"phone":"a10a3f92e9--phone--FU8Ha","phone-size-XS":"a10a3f92e9--phone-size-XS--lV3O_","phone-size-M":"a10a3f92e9--phone-size-M--IkNde"};